<template>
  <div class="bg-[#0B152A] min-h-screen overflow-y-auto dailyCashback">
    <!-- 吸顶导航栏 -->
    <van-nav-bar :title="t('misteriosa.title')" safe-area-inset-top :border="false"
      class="custom-nav-bar nav-bar-fixed sticky-nav">
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>

    <!-- 内容区域 -->
    <div class="content-container">
      <div class="relative px-[18px] pt-[16px] pb-[100px]">
        <img :src="getAssetsFile('activity/adwjs.png')" alt="" class="h-[365px] w-full absolute top-0 left-0 bg-image">
        <div class="titemsews">{{ t('misteriosa.title') }}</div>
        <div class="flex items-center green-container">
          <div class="greeenstyle" v-for="item in gerene" :key="item.name">
            <div class="text-white text-[14px] font-bold">{{ item.number }}</div>
            <div class="text-white text-[7px] font-bold">{{ item.name }}</div>
            <div class="dianst"></div>
          </div>
        </div>
        <div class="flex items-center mt-[10px] green-container" style="margin-top: 13px;">
          <img :src="getAssetsFile('activity/paopao.png')" alt="" class="h-[9px] w-[9px]">
          <div class="text-[#50D689] text-[11px] ">{{ t('misteriosa.eventCountdown') }}</div>
        </div>
        <div class="moneyseg" :style="{ backgroundImage: `url(${getAssetsFile('activity/gbs.png')})` }">
          <div class="flex items-center">
            <div class="moneyicon" :style="{ backgroundImage: `url(${getAssetsFile('activity/chengse.png')})` }">{{
              VITE_symbol }}</div>
            <div class="font-bold color-[#F5D24D] text-[17px] ml-[9px]">{{ todayEarnings }}</div>
          </div>
          <div class="text-[12px] color-[#ffffff] mt-[5px]">{{ t('misteriosa.todayEarnings') }}</div>
        </div>
        <div class="fersers">
          <div style="display: flex; align-items: flex-start;justify-content: space-between;flex-wrap: wrap; gap: 8px;">
            <div class="fersers-top" v-for="(item, index) in fersers" :key="index"
              :class="{ 'active-time': item.flag, 'inactive-time': !item.flag }">
              {{ formatTime(item.startTime) }} - {{ formatTime(item.endTime) }}
            </div>
          </div>
          <div class="flex items-center mt-[20px] justify-center mx-auto">
            <img :src="getAssetsFile('activity/gleft.png')" alt="" class="h-[9px] w-[9px]">
            <div class="text-[#FFFFFF] text-[15px] mx-[5px]">{{ t('misteriosa.activityRules') }}</div>
            <img :src="getAssetsFile('activity/gitright.png')" alt="" class="h-[10px] w-[10px]">
          </div>
          <img :src="getAssetsFile('activity/sese.png')" alt="" class="w-full my-[20px]">
          <div class="color-[#8BA4CC] text-[12px]">
            <div>{{ t('misteriosa.eventDetails') }}: </div>
            <div class="mt-[10px]">
              {{ t('misteriosa.rule1') }}
            </div>
            <div class="mt-[30px]">
              {{ t('misteriosa.rule2') }}
            </div>
            <div class="mt-[30px]">
              {{ t('misteriosa.rule3') }}
            </div>
            <div class="mt-[30px]">
              {{ t('misteriosa.rule4') }}
            </div>
            <div class="mt-[30px]">
              {{ t('misteriosa.rule5') }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="fixed-bottom-button">
      <div class="bottomBer" :style="{ backgroundImage: `url(${getAssetsFile('activity/buttons.png')})` }"
        @click="handleMiningClick">
        <div :class="buttonClass">{{ buttonText }}</div>
      </div>
    </div>

    <!-- wakdog 弹窗 -->
    <wakdog v-if="showWakdog" @close="handleWakdogClose" />

    <!-- 在模板最后添加 RewardDialog 组件 -->
    <RewardDialog v-model:show="showRewardDialog" :amount="rewardAmount" @confirm="handleRewardConfirm" />
  </div>
</template>

<script setup lang="ts">
import { Button } from "@/components/Button"
import { ref, onMounted, computed, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import * as GameApi from '@/api/game'
import wakdog from '@/pages/activity/components/wakdog.vue'
import RewardDialog from '@/components/RewardDialog.vue' // 导入 RewardDialog 组件
const VITE_symbol = import.meta.env.VITE_SYMBOL
const { t } = useI18n()
const router = useRouter()
const onClickLeft = () => router.back()

// 控制弹窗显示
const showWakdog = ref(false)
const showRewardDialog = ref(false) // 新增：控制 RewardDialog 的显示
const rewardAmount = ref<any>({}) // 新增：奖励金额

// 按钮状态：'active' | 'completed' | 'countdown'
const buttonState = ref('countdown')
const countdownTime = ref(0)

// 计算按钮文字
const buttonText = computed(() => {
  switch (buttonState.value) {
    case 'active':
      return t('misteriosa.mining')
    case 'completed':
      return t('misteriosa.alreadyMined')
    case 'countdown':
      const hours = Math.floor(countdownTime.value / 3600)
      const minutes = Math.floor((countdownTime.value % 3600) / 60)
      const seconds = countdownTime.value % 60
      const timeStr = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
      return t('misteriosa.closedCountdown', { time: timeStr })
    default:
      return t('misteriosa.mining')
  }
})

// 倒计时和矿洞数据
const mineData = ref({})
const todayEarnings = ref('0,00')
const fersers = ref([])

// 格式化时间，只显示小时和分钟
const formatTime = (timeString) => {
  if (!timeString) return ''
  return timeString.substring(0, 5)
}

// 倒计时定时器
let countdownTimer: NodeJS.Timeout | null = null

// 开始倒计时
const startCountdown = () => {
  if (countdownTimer) {
    clearInterval(countdownTimer)
  }

  countdownTimer = setInterval(() => {
    if (countdownTime.value > 0) {
      countdownTime.value--
    } else {
      // 倒计时结束，重新获取状态
      getMineCountdown()
    }
  }, 1000)
}

// 获取神秘矿洞数据
const getMineCountdown = async () => {
  try {
    const res = await GameApi.CountdownToMine()
    mineData.value = res.data
    todayEarnings.value = res.data.todayReward || '0,00'

    // 根据 hasClaimed 字段判断按钮状态
    if (res.data && res.data.hasClaimed !== undefined) {
      switch (res.data.hasClaimed) {
        case 0:
          buttonState.value = 'completed' // 已领取
          break
        case 1:
          buttonState.value = 'active' // 可领取
          break
        case 2:
          buttonState.value = 'countdown' // 倒计时中
          break
        default:
          buttonState.value = 'countdown'
      }
    }

    // 如果有倒计时数据，设置倒计时时间
    if (res.data && res.data.countDown) {
      countdownTime.value = res.data.countDown
    }

    // 只有在倒计时状态时才启动倒计时
    if (buttonState.value === 'countdown' && countdownTime.value > 0) {
      startCountdown()
    }

    // 处理时间段数据
    if (res.data.mysteriousMineTimeList) {
      fersers.value = res.data.mysteriousMineTimeList.map(item => ({
        ...item,
        flag: item.flag
      }))
    }
  } catch (error) {
    console.error('获取神秘矿洞数据失败:', error)
  }
}

// 挖矿按钮点击处理
const handleMiningClick = async () => {
  if (buttonState.value === 'active') {
    try {
      console.log('开始挖矿领奖')
      const res = await GameApi.CountdownreceiveTheAward()
      console.log('挖矿领奖结果:', res)

      // 显示成功提示
      if (res.code === 0 || res.code === 200) {
        // 显示奖励弹窗，传递领取的金额
        rewardAmount.value = res.data
        showRewardDialog.value = true

        // 注意：这里不立即刷新数据，等弹窗确认后再刷新
        // await getMineCountdown() // 注释掉这行，等弹窗确认后再刷新
      } else {

      }
    } catch (error) {

    }
  }
}

// 处理奖励确认
const handleRewardConfirm = async () => {
  // 弹窗关闭后的处理逻辑
  console.log('奖励已确认')

  // 等待一下确保API处理完成
  await new Promise(resolve => setTimeout(resolve, 500))

  // 刷新数据，这会更新按钮状态
  await getMineCountdown()
}

// 页面加载时自动弹出
onMounted(() => {
  showWakdog.value = true
  getMineCountdown()
})

// 组件卸载时清理定时器
onBeforeUnmount(() => {
  if (countdownTimer) {
    clearInterval(countdownTimer)
  }
})

// 处理弹窗关闭
const handleWakdogClose = async () => {
  showWakdog.value = false
  // 弹窗关闭时调用接口
  await getMineCountdown()
}

const gerene = ref([
  { number: 99, name: t('misteriosa.day') },
  { number: 99, name: t('misteriosa.hours') },
  { number: 99, name: t('misteriosa.minutes') },
  { number: 99, name: t('misteriosa.seconds') }
])

const buttonClass = computed(() => {
  switch (buttonState.value) {
    case 'active':
      return 'aniusbuttons-active'
    case 'completed':
    case 'countdown':
      return 'aniusbuttons-inactive'
    default:
      return 'aniusbuttons-active'
  }
})
</script>

<style lang="scss" scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.3), 0px -2px 22px 0px rgba(53, 189, 128, 0.61);

  &>* {
    height: 100%;
  }
}

/* 吸顶导航栏样式 */
.sticky-nav {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

/* 内容区域，为吸顶导航栏留出空间 */
.content-container {
  margin-top: 46px;
  /* 导航栏高度 */
  padding-top: 1px;
}

/* 确保页面有足够的高度 */
.dailyCashback {
  min-height: 100vh;
  position: relative;
  --van-nav-bar-background: #000000;
  --van-nav-bar-text-color: #fff;
  --van-nav-bar-title-text-color: #fff;
  --van-nav-bar-icon-color: #fff;
}

.nav-bar-fixed {
  position: relative;
  z-index: 9999;
}

.bg-image {
  z-index: 1;
}

.titemsews {
  position: relative;
  z-index: 2;
  font-weight: bold;
  font-size: 34px;
  background: linear-gradient(270deg, #4B46A3 40%, #870216 80%, #FFB637 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -webkit-text-stroke: 1px #E9D3A9;
  text-stroke: 2px #E9D3A9;
  font-weight: bold;
}

.green-container {
  position: relative;
  z-index: 4;
  margin-top: 20px;
}

.greeenstyle {
  width: 35px;
  height: 43px;
  background: linear-gradient(0deg, #32547E 0%, #5AE580 100%);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-right: 8px;
  position: relative;
  z-index: 3;
  padding: 4px 0 0 0;
}

.dianst {
  width: 7px;
  height: 3px;
  background: #FFB84F;
  display: block;
  margin-top: 0;
  margin-bottom: 0;
}

.moneyseg {
  background: no-repeat center center;
  background-size: 100% 100%;
  width: 173px;
  height: 69px;
  z-index: 5;
  position: relative;
  left: -10px;
  margin-top: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-right: 10px;
}

.moneyicon {
  width: 16px;
  height: 16px;
  background: no-repeat center center;
  background-size: 100% 100%;
  font-size: 7px;
  font-weight: bold;
  text-align: center;
  line-height: 16px;
  color: #FFFFFF;
}

.fersers {
  width: 100%;
  background: linear-gradient(0deg, #151543 62%, #242E50 100%);
  border-radius: 13px !important;
  z-index: 9;
  position: relative;
  margin-top: 56px;
  color: #3FC950;
  font-size: 11px;
  padding: 26px 16px;
}

.fersers-top {
  background: #1B1E44;
  border-radius: 6px;
  padding: 8px 6px;
  border: 1px solid #2B2D6D;
  width: calc((100% - 16px) / 3);
  text-align: center;
  margin-bottom: 2px;
  font-size: 10px;
  min-width: 0;
  flex-shrink: 0;
}

.active-time {
  color: #3FC950 !important;
  font-weight: bold;
}

.inactive-time {
  color: #6A6A6A !important;
  opacity: 0.6;
}

/* 新的底部按钮样式 */
.fixed-bottom-button {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: transparent;
  padding: 10px 16px;
  padding-bottom: calc(10px + env(safe-area-inset-bottom, 0));
}

.bottomBer {
  width: 100%;
  max-width: 320px;
  margin: 0 auto;
  text-align: center;
  font-size: 13px;
  cursor: pointer;
  padding: 12px 15px;
  border-radius: 8px;
  overflow: hidden;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 激活状态（可领取）高亮 */
.aniusbuttons-active {
  background: linear-gradient(90deg, #DFC739 0%, #A14D53 100%);
  color: #fff !important;
  box-shadow: 0px 1px 1px 0px rgba(21, 21, 67, 0.4);
  font-weight: bold;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 6px;
  width: 100%;
}

/* 非激活状态（已领取/倒计时）灰色 */
.aniusbuttons-inactive {
  background: linear-gradient(90deg, #74724A 0%, #5B4155 100%);
  color: #7F889A !important;
  font-weight: bold;
  cursor: not-allowed;
  height: 30px;
  box-shadow: 0px 1px 1px 0px rgba(21, 21, 67, 0.4);
  line-height: 30px;
  transition: all 0.3s;
  border-radius: 6px;
  width: 100%;
}

/* 移动端适配 */
@media screen and (max-width: 375px) {
  .fersers-top {
    width: calc((100% - 8px) / 3);
    padding: 6px 4px;
    font-size: 9px;
  }
}

@media screen and (max-width: 320px) {
  .fersers-top {
    width: calc((100% - 8px) / 3);
    padding: 4px 2px;
    font-size: 8px;
  }
}
</style>
